import { Box, Layer, Text } from 'grommet';

export const ModalBase = ({ title, children }: { title: string; children: any }): JSX.Element => {
  return (
    <Layer background={{ opacity: 0.7 }}>
      <Box
        data-cy={'field-processing-modal'}
        background={'white'}
        direction={'column'}
        alignSelf={'center'}
        height={'fit-content'}
        width={'80%'}
        pad={'24px'}
        className={'hideScrollBox'}
        overflow={'auto'}
        style={{ borderRadius: '1rem', display: 'unset', maxHeight: '95vh' }}
        align={'center'}
        justify={'center'}>
        <Text
          size={'33px'}
          weight={600}
          style={{
            lineHeight: '37px',
            marginTop: 0,
            display: 'flex',
            justifyContent: 'center',
          }}>
          {title}
        </Text>
        {children}
      </Box>
    </Layer>
  );
};
